export const colors = {
  light: "#fff",
  //-- UI V2
  bg: "#f5f7fb",
  bgRed: "#fef2f2",
  primary: "#2196f3",
  primaryLight: "#4fb0f7",
  primaryActive: "#E3F2FD",
  primaryHover: "#F9FAFB",
  green: "#10B981",
  bgGreen: "#D1FAE5",
  bgGray1: "#eeeeee",
  gray100: "#e1e1e1",
  gray200: "#acacac",
  gray: "#8B8B8B",
  grayDark: "#1f1f1f",
  danger: "#EF4444",
  dangerLight: "#fbb5b7",
  amber: "#F59E0B",
  bgAmber: "#FEF3C7",
  amberDark: "#92400E",
  //-- 裝飾用的鵝黃。與上面的 amber 是兩件事：amber 是「留意」的狀態語意色，
  //   這兩個只做點綴（慶祝、空狀態、螢光筆），不得用來表達任何狀態。
  //   明度刻意壓得比 amber 淺一大階，就是為了讓兩者在同一個畫面裡不會被誤認。
  warm: "#fde68a",
  warmMark: "#fcd34d",
  purple: "#8B5CF6",
  bgPurple: "#EDE9FE",
  purpleDark: "#6D28D9",
  blueGreen: "#008A93",

  //-- Order status accent colors (對齊 lpg-aw-api / lpg-dapp-api flex message)
  statusPending: "#F59E0B", // 待確認
  statusWaiting: "#3B82F6", // 待接單
  statusDelivering: "#7C3AED", // 配送中
  statusCompleted: "#16A34A", // 已完成

  //-- UI V2 neutrals & tints (帳戶區切版共用)
  text: "#0F172A",
  sub: "#64748B",
  hint: "#94A3B8",
  border: "#E2E5EB",
  borderLight: "#ECEEF2",
  primaryBg: "#EFF6FF",
  primaryText: "#1E40AF",
  greenText: "#065F46",
  redText: "#991B1B",

  //-- UI V1 (legacy)
  // blue:
  dividerBlue: "#004E7A",
  dakerBlue: "#086396",
  fontBlue: "#006CAA",
  subBlue: "#0281C8",
  stepBlue: "#0097D7",
  btnBlue: "#0097D7",
  lightblue: "#CEE7F1",
  lightblue2: "#69C2E9",
  lightBlueBG: "#CBE4EE",
  btnBlue2: "#0066FF",
  btnLightBlue: "#EDF1F7",
  // gray:
  bgGray: "#DCDCDC",
  bgGray2: "#F6F6F6",
  bgGray3: "#F6F6F8",
  subTitle: "#252525",
  subTitleGray: "#CCCCCC",
  subTitleGray2: "#5F5F5F",
  placeGray: "#8B8B8B",
  notifyGray: "#808080",
  tabsGray: "#888888",
  grayColor: "#464646",
  grayColor2: "#929292",
  middleGray: "#868686",
  infoGray: "#676767",
  infoGray2: "#737373",
  dividerGray: "#AFAFAF",
  orderListBg: "#F6F6F8",
  orderListBg2: "#F8F6F6",
  stepGray: "#E5E5E5",
  inputBg: "#E3E3E3",
  lightGray: "#ECECEC",
  // red
  badgeRed: "#E27377",
  darkRed: "#DB0303",
  // black
  subBlack: "#393939",
  lightBlack: "#505050",
  // green
  homeGreen: "#00B191",

  lightGreen: "#0096A0",
  lineGreen: "#03BD00",
  // orange
  lightOrange: "#F6B57A",
};
